import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';

import { Tokens } from '../types';

import { vkTokens } from './vk.tokens';

export const vkDarkTokens: Tokens = merge(cloneDeep(vkTokens), {
  name: 'vk-dark',
  colors: {
    original: {
      brand: {
        secondary: '#20252d',
        quaternary: '#233044',
      },
    },
    text: {
      light: {
        primary: '#fbfbfb',
        secondary: '#aeaeae',
        tertirary: '#797979',
      },
    },
    stroke: {
      primary: '#404143',
    },
    bg: {
      light: {
        primary: '#171717',
        secondary: '#1f1f1f',
        tertirary: '#121212',
      },
      greyscale: {
        primary: '#212224',
        secondary: '#202020',
        tertirary: '#20252d',
      },
    },
    accent: {
      bg: {
        error: '#2b2121',
        success: '#20251d',
        warning: '#252018',
        review: '#2a232f',
        blue: '#20252d',
      },
    },
  },
});
